<script>
    import { createEventDispatcher } from 'svelte';
    export let label = "Read more";
    export let colour = "#ffe500";
    export let activeColour = "blue"
    export let activeText = 'white'
    export let active = false;
    
    let width = 0;
    const dispatch = createEventDispatcher();
    
    function handleClick(event) {
      dispatch('click', event);
    }
  </script>
    
  <button
    class="guardian-button button-sm"
    on:click={handleClick}
    style="background-color: {active ? activeColour : 'white' }; color: {active ? colour : 'white' }; width: {width + 15}px; border: 1px solid {colour};"
  >
    <div class="_button_wrap" bind:clientWidth={width}>
      <div class="label" style="color:{active ? 'white' : colour }">{label}</div>
    </div>
  </button>
    
  <style lang="scss">
    .guardian-button {
      padding: 0 5px;
      border: none;
      border-radius: 36px;
      margin-top: 12px;
      height: 36px;
      margin-right: 10px;
      cursor: pointer;
  
      div {
        float: left;
      }
  
      svg {
        rotate: 90deg;
      }
  
      ._button_wrap {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 5px;
      }
      
      .label {
        display: flex;
        vertical-align: middle;
        font-family: var(--text-sans);
        font-size: var(--sans-small);
        line-height: var(--sans-line-height);
        font-weight: 700;
        padding: 0 4px;
      }
      
      .icon {
        display: flex;
      }
      
      &.button-md {
        height: 44px;
        padding: 0 12px;
      }
    }
  </style>
  